export default "__VITE_ASSET__8LgAx4tV__"